module.exports = __webpack_public_path__ + "static/media/translations.1029.f7a891e6.resx";